import { react2angular } from 'react2angular';

import { ListingDetailsComponents, QuickActionButtons } from 'components';
import AddListingToTourButton from '../../../Router/pages/TourEditPage/AddListingToTourButton';
import AnsweringTag from './AnsweringTag';

angular
  .module('bb.listing_view', ['ngRoute', 'ngMap'])
  .component(
    'bbAnsweringTag',
    react2angular(AnsweringTag, ['subscription', 'useAppointmentDesk']),
  )
  .component(
    'bbListingDetailsAttachments',
    react2angular(ListingDetailsComponents.PublicAttachments, ['attachments']),
  )
  .component(
    'bbListingDetailsPendingAlert',
    react2angular(
      ListingDetailsComponents.PendingListingWarning,
      ['listing', 'auth', 'external', 'isInternalAdmin'],
      ['$rootScope'],
    ),
  )
  .component(
    'bbQuickActionButtons',
    react2angular(QuickActionButtons, [
      'listingId',
      'isFavorite',
      'toggleFavorite',
      'isCoopAgent',
    ]),
  )
  .component(
    'bbAddListingToTourButton',
    react2angular(AddListingToTourButton, ['listing', 'preBookingInformation']),
  );

require('./listing_view.service');

require('./listing_view.component');
require('./listing_view_internal.component');

require('./listing_view_carousel.directive');
require('./listing_view_asset.directive');
require('./listing_view_asset_modal.directive');
require('./listing_buttons.directive');

require('./listing_view.routes');
